<template>
	<div>
    <download-app-notif></download-app-notif>
	  <div class="box as-wrapper has-background-primary" style="box-shadow: 0 0.5px 0 0 #fff inset,0 1px 2px 0 rgba(0,0,0,0.08) !important;">
	    <div class="columns is-mobile is-gapless is-vcentered">
	      <div class="column has-text-left is-narrow">
	        <a href="" class="" style="color: #C6E8C5;" @click.prevent="$router.back()">
	          <b-icon icon="arrow-left"></b-icon>
	        </a>
	      </div>
        <div class="column"></div>

	      <div class="column has-text-centered is-8 truncated-text">
	        <nuxt-link :to="{path: '/panel'}">
	        	<span v-if="!isEmpty($store.state.universities.active)"><strong class="" style="color: #C6E8C5;">{{ $store.state.universities.active.name }}</strong></span>
	        	<span v-else>
	        		<figure class="image" style="width: 80px; max-height: 34px; margin: 0 auto;">
	        			<img src="/assets/img/logo-white-new.png" alt="">
	        		</figure>
	        	</span>
	        </nuxt-link>
	      </div>

	      <div class="column has-text-right">
	        <nuxt-link class="" style="color: #C6E8C5;" :to="{path: '/panel/notifications'}">
	          <b-icon icon="bell"></b-icon>
	        </nuxt-link>
	      </div>

        <div class="column is-narrow has-text-left" style="margin-left: 10px;">
          <a href="" class="" style="color: #C6E8C5;" @click.prevent="active = true">
            <b-icon icon="menu"></b-icon>
          </a>
        </div>
	    </div>
	  </div>

    <!-- Sidebar Menu -->
	  <section class="hero is-light is-fullheight" style="position: fixed; top: 0; left: 0; z-index: 2; width: 100%;" v-if="active">
		  <div class="hero-body">
        <div class="columns is-mobile is-centered is-vcentered" style="position: absolute; top: 10px; width: 100%; left: 11px;">
          <div class="column">
            <figure class="image is-32x32">
              <img v-if="!isEmpty($store.state.universities.active)" :src="$store.state.universities.active.logoOnly"/>
              <img v-else :src="$icon('64')" alt="">
            </figure>
          </div>

          <div class="column is-narrow">
            <a href="" class="delete" @click.prevent="active = false"></a>
          </div>
        </div>

		    <div class="container">
					<b-menu>
				    <b-menu-list label="Menu">
              <span v-for="(menu, key) in menus" :key="key">
							  <b-menu-item v-if="isCanSeeMenu(menu) && isEmpty(menu.submenus)" :label="menu.name" tag="router-link" :to="{path: goto(menu)}"></b-menu-item>
              </span>

              <span v-for="(menu, key) in menus" :key="key">
                <b-menu-item v-if="isCanSeeMenu(menu) && !isEmpty(menu.submenus)" :label="menu.name">
                  <span v-for="(sm, q) in menu.submenus" :key="q">
                    <b-menu-item v-if="isCanSeeMenu(sm)" :label="sm.name" tag="router-link" :to="{path: goto(sm)}"></b-menu-item>
                  </span>
                </b-menu-item>
              </span>
				    </b-menu-list>

            <b-menu-list label="Akun">
              <span v-for="(menu, key) in account_menus" :key="key">
                <b-menu-item v-if="isCanSeeMenu(menu) && isEmpty(menu.submenus)" :label="menu.name" tag="router-link" :to="{path: goto(menu)}"></b-menu-item>
              </span>

              <span v-for="(menu, key) in menus" :key="key">
                <b-menu-item v-if="isCanSeeMenu(menu) && !isEmpty(menu.submenus)" :label="menu.name">
                  <span v-for="(sm, q1) in menu.submenus" :key="q1">
                    <b-menu-item v-if="isCanSeeMenu(sm)" :label="sm.name" tag="router-link" :to="{path: goto(sm)}"></b-menu-item>
                  </span>
                </b-menu-item>
              </span>

              <b-menu-item label="Keluar" @click.prevent="logout"></b-menu-item>
            </b-menu-list>
				  </b-menu>
		    </div>
		  </div>
		</section>
	 </div>
</template>

<script>
import NAVBAR_MIXIN from '~/mixins/navbar'
import { mapActions } from 'vuex'
import DownloadAppNotif from '~/components/DownloadAppNotif'

export default {
  components: {
    DownloadAppNotif
  },

	mixins: [NAVBAR_MIXIN],

	computed: {
		menus() {
			return this.left_menus.concat(this.right_menus)
		}
	},

	watch: {
		'$route'() {
			this.active = false
		}
	},

	data() {
		return {
			active: false,
		}
	},

	methods: {
    ...mapActions({
      logout: 'logout'
    }),
		goto(menu) {
			return '/' + menu.value
		}
	}
}
</script>
